<template>
  <div
    id="app"
    class="transition-all"
    :class="{
      'overflow-hidden': $route.path === '/bot/mail/reply',
      'fill-page': fillPageRoutes.includes($route.path),
    }"
  >
    <router-view />
    <!-- 全局套餐上限弹窗由 Axios 事件唤起，因此放在根节点以覆盖任意业务页面。 -->
    <PackageLimitDialog />
    <!-- 全局套餐到期弹窗由路由守卫事件唤起，因此放在根节点以覆盖任意业务页面。 -->
    <PackageExpiredDialog />
    <PackageLockedDialog/>
    <!-- WhatsApp WebSocket 余额不足事件由聊天页触发，根节点保证路由切换时仍能展示。 -->
    <WhatsAppBalanceInsufficientDialog />
  </div>
</template>

<script>
import { inertScript } from "@/utils/insertScript";
import { clearLocalStorageKeepSidebarPinned } from "@/utils/storage";
import PackageLimitDialog from "@/components/globalDialog/PackageLimitDialog.vue";
import PackageExpiredDialog from "@/components/globalDialog/PackageExpiredDialog.vue";
import PackageLockedDialog from "@/components/globalDialog/PackageLockedDialog.vue";
import WhatsAppBalanceInsufficientDialog from "@/components/globalDialog/WhatsAppBalanceInsufficientDialog.vue";


export default {
  name: "App",
  components: {
    PackageLimitDialog,
    PackageExpiredDialog,
    PackageLockedDialog,
    WhatsAppBalanceInsufficientDialog
  },
  data() {
    return {
      fillPageRoutes: ["/chatBotInsertion", "/chatBotInsertError"],
    };
  },
  beforeCreate() {
    // 当前项目固定使用 JoinCompass 品牌，不再根据访问域名切换应用名称。
    this.$store.commit("SET_APP_NAME", "JoinCompass");
  },
  created() {
    const token = this.$store.getters["authoState/token"];
    const user_info = this.$store.getters["authoState/user_info"];
    if (token && !user_info.curr_team_id) {
      this.$store.commit("authoState/CLEAR_AUTH_STATE");
      clearLocalStorageKeepSidebarPinned();
    }
  },
  beforeMount() {
    inertScript();
  },
  /*watch: {
    "$route.path": {
      immediate:true,
      handler(path) {
        const script = document.getElementById('bd-script');
        const NODE_ENV = process.env.NODE_ENV;
        const isMcInsertPages = this.fillPageRoutes.includes(path);
        if (NODE_ENV !== "production") {
          if (script) {
            script.remove();
          }
          return;
        }
        if (isMcInsertPages) {
          script.src = "https://hm.baidu.com/hm.js?ad9d540f2174b878cf0451bfb8a60d41";
        } else {
          script.src = "https://hm.baidu.com/hm.js?d0d23e67fc83bb251ade89d690021e8c"
        }
      }
    }
  }*/
};
</script>
<style lang="scss" scoped>
.fill-page {
  min-width: auto !important;
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
